import React from 'react';
import { Card, CardContent, Grid, Box } from '@mui/material';

import HotelCardImageMap from './HotelCardImage/HotelCardImageMap';
import HotelPriceInfo from './HotelPriceInfo';
import HotelName from './HotelCardInfoBlocks/HotelName';
import HotelRating from './HotelCardInfoBlocks/HotelRating';
import TarifaInfo from './HotelCardInfoBlocks/TarifaInfo';
import RegimenInfo from './HotelCardInfoBlocks/RegimenInfo';
import { getCheapestRate } from '@shared/helpers';

const HotelCardMap = ({
  hotel,
  hasIdFav,
  isLoadImage,
  setIsLoadImage,
  getFavConfig,
  handleImageError,
  defaultImage,
  handleChangePage,
  compare,
  isFromMap,
  handleCloseModal,
}) => {
  const cheapestRate = getCheapestRate(hotel.rates);
  const isNonRefundable = !cheapestRate?.cancel_cost?.[0]?.CanBeCanceled;
  const idIntegration = hotel?.id_integration;
  const boardDescription = cheapestRate?.board?.description || '';

  return (
    <Card sx={{ cursor: 'pointer' }} onClick={handleChangePage}>
      <HotelCardImageMap
        {...{
          hotel,
          hasIdFav,
          isLoadImage,
          setIsLoadImage,
          getFavConfig,
          handleImageError,
          defaultImage,
          handleCloseModal,
        }}
      />

      <CardContent sx={{ p: '8px 12px', '&:last-child': { pb: 1.5 } }}>
        <Grid
          container
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            pb: 0.5,
            height: { xs: 'auto', sm: 'initial' },
          }}
        >
          <Box sx={{ flex: 1, mr: 1, overflow: 'hidden' }}>
            <HotelName name={hotel.name} isFromMap />
          </Box>
          <HotelRating rating={hotel.rating} isFromMap />
        </Grid>
        <HotelPriceInfo
          {...{
            hotel,
            rate: cheapestRate,
            compare,
            isFromMap,
          }}
        />
        <Grid container direction="column" spacing={1}>
          <Grid item xs={12}>
            <RegimenInfo
              boardDescription={boardDescription}
              rate={cheapestRate}
            />
          </Grid>

          <Grid item xs={12}>
            <TarifaInfo
              isNonRefundable={isNonRefundable}
              idIntegration={idIntegration}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default HotelCardMap;
